import React from 'react';

const ThreeDotIcon = () => {
  return (
    <svg
      width='18'
      height='4'
      viewBox='0 0 18 4'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M-3.49691e-07 2C-1.56662e-07 0.896 0.896 1.56662e-07 2 3.49691e-07C3.104 5.42721e-07 4 0.896001 4 2C4 3.104 3.104 4 2 4C0.895999 4 -5.42721e-07 3.104 -3.49691e-07 2ZM9 1.57361e-06C7.896 1.38058e-06 7 0.896001 7 2C7 3.104 7.896 4 9 4C10.104 4 11 3.104 11 2C11 0.896002 10.104 1.76664e-06 9 1.57361e-06ZM16 2.79753e-06C14.896 2.6045e-06 14 0.896002 14 2C14 3.104 14.896 4 16 4C17.104 4 18 3.104 18 2C18 0.896003 17.104 2.99056e-06 16 2.79753e-06Z'
        fill='#828282'
      />
    </svg>
  );
};

export default ThreeDotIcon;
